module.exports = __webpack_public_path__ + "img/i_h2_function4.de560660.svg";